/* tslint:disable */
/* eslint-disable */
/**
 * SLM API used by SLM frontend
 * This is the specification of the backend APIs. The main purpose of this specification is to unify the API between SLM-backend and SLM-frontend. For localizations the Accept-Language header is used.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dl.mhs.bd3.se@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DeliveryTypeEnum = {
    MULTIPACK: '0',
    PALLET: '1',
} as const;
export type DeliveryTypeEnum = typeof DeliveryTypeEnum[keyof typeof DeliveryTypeEnum];


export function instanceOfDeliveryTypeEnum(value: any): boolean {
    for (const key in DeliveryTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(DeliveryTypeEnum, key)) {
            if (DeliveryTypeEnum[key as keyof typeof DeliveryTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DeliveryTypeEnumFromJSON(json: any): DeliveryTypeEnum {
    return DeliveryTypeEnumFromJSONTyped(json, false);
}

export function DeliveryTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryTypeEnum {
    return json as DeliveryTypeEnum;
}

export function DeliveryTypeEnumToJSON(value?: DeliveryTypeEnum | null): any {
    return value as any;
}

export function DeliveryTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DeliveryTypeEnum {
    return value as DeliveryTypeEnum;
}

